import { render, staticRenderFns } from "./IconsV2.vue?vue&type=template&id=a63efbdc&scoped=true"
import script from "./IconsV2.vue?vue&type=script&lang=js"
export * from "./IconsV2.vue?vue&type=script&lang=js"
import style0 from "./IconsV2.vue?vue&type=style&index=0&id=a63efbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63efbdc",
  null
  
)

export default component.exports